import {Trans} from '@lingui/macro';
import React, {FC} from 'react';

import {Handler} from '../../../libs/shared/helpers/src/react/reactHelpers';
import {isTeammateNamespace} from '../../helpers/models/namespaceHelpers';
import {SettingsSidebarInfoBox} from '../common/settingsSidebarInfoBox';

/*
 * Props.
 */

interface SettingsAnswersListSidebarProps {
  namespace: string;
  onCloseClick: Handler;
  onFooterClick: Handler;
}

/*
 * Component.
 */

export const SettingsAnswersListSidebar: FC<SettingsAnswersListSidebarProps> = (props) => {
  if (isTeammateNamespace(props.namespace)) {
    return (
      <SettingsSidebarInfoBox
        title={
          <Trans id="settingsmessagetemplates-infobox-private-title">Individual message templates</Trans>
        }
        body={
          <p>
            <Trans id="settingsmessagetemplates-infobox-private-body">
              You can use message templates to reply quickly to conversations. You can use variables in your
              templates to fill in dynamic content, such as the recipient&quot;s name, inside your template.
              Individual message templates are only accessible to you and can be used in any inbox.
            </Trans>
          </p>
        }
        footer={<Trans id="settingsmessagetemplates-infobox-private-footer">Learn more</Trans>}
        onCloseClick={props.onCloseClick}
        onFooterClick={props.onFooterClick}
      />
    );
  }

  return (
    <SettingsSidebarInfoBox
      title={<Trans id="settingsmessagetemplates-infobox-team-title">Team message templates</Trans>}
      body={
        <p>
          <Trans id="settingsmessagetemplates-infobox-team-body">
            You can use message templates to reply quickly to conversations. You can use variables in your
            templates to fill in dynamic content, such as the recipient&quot;s name, inside your template.
          </Trans>
        </p>
      }
      footer={<Trans id="settingsmessagetemplates-infobox-private-footer">Learn more</Trans>}
      onCloseClick={props.onCloseClick}
      onFooterClick={props.onFooterClick}
    />
  );
};
